/* TwentySix collection grid: Shop the look (snippets/ts-look.liquid + ts-look-item.liquid, styles in ts-look.css).
   A tap on a look photo opens one panel with the pieces in the photo, all ticked: pick a size (always in the colour
   shown in the photo, a piece whose colour is gone shows as sold out), untick what she doesn't want, and the picked pieces go to the bag in one go, then the bag opens.
   Phones and tablets get a bottom sheet, desktop the photo beside the list. Clicks are caught on the document, so looks
   that come in with load more work too. Without this file the photo stays a plain link to the first piece. */
(function () {
  if (window.TSLook) return;
  window.TSLook = true;

  var T = {
    size: 'בחרי מידה',
    color: 'בחרי צבע',
    none: 'סמני לפחות פריט אחד',
    error: 'משהו השתבש, אפשר לנסות שוב',
    close: 'סגירה',
    sold: 'Sold out',
    one: 'One size',
    look: 'Add the look',
    add: 'Add to bag'
  };
  var SIZE = /size|מיד/i, COLOR = /colou?r|צבע/i;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var panel = null, el = {}, look = null, opener = null, busy = false, closing = 0;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  /* the store's own money format, read from "100 | money" (cents in, the same text as the cards out) */
  function money(c) {
    var m = (look && look.m) || '₪1', dec = /\d[.,]\d\d(?!\d)/.test(m), v = c / 100;
    var s = dec ? v.toFixed(2) : String(Math.round(v));
    if (v >= 1000) s = s.replace(/^(\d+)(\d{3})/, '$1,$2');
    return m.replace(/\d+(?:[.,]\d+)?/, s);
  }

  /* ---------- the panel (built once, on the first tap) ---------- */
  function build() {
    panel = document.createElement('div');
    panel.className = 'tsl';
    panel.hidden = true;
    panel.innerHTML =
      '<div class="tsl__shade" data-tsl-x></div>' +
      '<div class="tsl__box" role="dialog" aria-modal="true" aria-labelledby="tsl-t" tabindex="-1">' +
        '<div class="tsl__pic"><img alt="" decoding="async"></div>' +
        '<div class="tsl__main">' +
          '<div class="tsl__grab" aria-hidden="true"></div>' +
          '<div class="tsl__head" dir="ltr" lang="en">' +
            '<div class="tsl__hd"><p class="tsl__k">Shop the look</p><p class="tsl__t" id="tsl-t"></p></div>' +
            '<button type="button" class="tsl__x" data-tsl-x aria-label="' + T.close + '"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg></button>' +
          '</div>' +
          '<ul class="tsl__list" role="list" dir="rtl" lang="he"></ul>' +
          '<div class="tsl__foot">' +
            '<p class="tsl__msg" role="alert" dir="auto"></p>' +
            '<button type="button" class="tsl__go"><span class="tsl__bl"></span><span class="tsl__sum"></span></button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(panel);
    el.box = panel.querySelector('.tsl__box');
    el.img = panel.querySelector('.tsl__pic img');
    el.t = panel.querySelector('.tsl__t');
    el.list = panel.querySelector('.tsl__list');
    el.msg = panel.querySelector('.tsl__msg');
    el.go = panel.querySelector('.tsl__go');
    el.bl = panel.querySelector('.tsl__bl');
    el.sum = panel.querySelector('.tsl__sum');

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-tsl-x]')) { close(true); return; }
      var chip = e.target.closest('.tsl__c');
      if (chip && !chip.disabled) { choose(chip); return; }
    });
    el.list.addEventListener('change', function (e) {
      var box = e.target.closest('.tsl__tick input');
      if (!box) return;
      var it = look.items[+box.closest('.tsl__it').getAttribute('data-i')];
      it.on = box.checked;
      if (!it.on) need(it, '');
      el.msg.textContent = '';
      sync();
    });
    el.go.addEventListener('click', add);
    document.addEventListener('keydown', function (e) {
      if (!panel || panel.hidden || !panel.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(true); return; }
      if (e.key === 'Tab') trap(e);
    });
    /* phones: pull the sheet down by its top edge to close it */
    var head = panel.querySelector('.tsl__grab'), hd = panel.querySelector('.tsl__head'), y0 = null, dy = 0;
    [head, hd].forEach(function (h) {
      h.addEventListener('touchstart', function (e) { if (window.innerWidth >= 1024) return; y0 = e.touches[0].clientY; dy = 0; el.box.style.transition = 'none'; }, { passive: true });
      h.addEventListener('touchmove', function (e) { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); el.box.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
      h.addEventListener('touchend', function () {
        if (y0 == null) return;
        y0 = null; el.box.style.transition = ''; el.box.style.transform = '';
        if (dy > 90) close(true);
      });
    });
  }

  function trap(e) {
    var f = [].slice.call(el.box.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === el.box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- one look ---------- */
  function prep(data) {
    data.items.forEach(function (it) {
      it.kind = it.o.map(function (n) { return COLOR.test(n) ? 'c' : (SIZE.test(n) ? 's' : 'x'); });
      /* only the colour in the photo is offered: the other colours drop out and she picks a size */
      it.kind.forEach(function (kind, k) {
        if (kind !== 'c' || !it.pc) return;
        var same = it.v.filter(function (v) { return v.o[k] === it.pc; });
        if (same.length) it.v = same;
      });
      it.live = it.v.some(function (v) { return v.a; });
      it.on = it.live;
      it.sel = [];
      it.o.forEach(function (n, k) {
        var vals = uniq(it.v.map(function (v) { return v.o[k]; }));
        it.sel[k] = vals.length === 1 ? vals[0] : null;
      });
    });
    return data;
  }
  function uniq(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function fits(it, v, skip) {
    for (var k = 0; k < it.sel.length; k++) if (k !== skip && it.sel[k] != null && v.o[k] !== it.sel[k]) return false;
    return true;
  }
  function variant(it) {
    for (var i = 0; i < it.v.length; i++) if (fits(it, it.v[i], -1) && it.sel.every(function (s) { return s != null; })) return it.v[i];
    return null;
  }
  function price(it) {
    var v = variant(it);
    if (v) return v.p;
    var vs = it.v.filter(function (x) { return x.a && fits(it, x, -1); });
    if (!vs.length) vs = it.v;
    return Math.min.apply(null, vs.map(function (x) { return x.p; }));
  }
  function img(it) {
    var v = variant(it) || it.v.filter(function (x) { return fits(it, x, -1) && x.i; })[0];
    return (v && v.i) || it.img;
  }

  function row(it, i) {
    var opts = '';
    if (!it.live) {
      opts = '<span class="tsl__one">' + T.sold + '</span>';
    } else {
      var multi = false;
      it.o.forEach(function (n, k) {
        var vals = uniq(it.v.map(function (v) { return v.o[k]; }));
        if (vals.length < 2) return;
        multi = true;
        opts += '<div class="tsl__cs tsl__cs--' + it.kind[k] + '" role="group" aria-label="' + esc(n) + '" dir="ltr">' + vals.map(function (val) {
          return '<button type="button" class="tsl__c" data-k="' + k + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('') + '</div>';
      });
      if (!multi) opts = '<span class="tsl__one">' + T.one + '</span>';
    }
    return '<li class="tsl__it' + (it.live ? '' : ' is-off') + '" data-i="' + i + '">' +
      '<label class="tsl__tick"><input type="checkbox"' + (it.on ? ' checked' : '') + (it.live ? '' : ' disabled') + ' aria-label="' + esc(it.t) + '"><span class="tsl__tb" aria-hidden="true"><svg viewBox="0 0 12 12"><path d="M2.5 6.2l2.3 2.3 4.7-5"/></svg></span></label>' +
      '<a class="tsl__th" href="' + esc(it.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img(it)) + '" alt="" decoding="async"></a>' +
      '<div class="tsl__in">' +
        '<div class="tsl__r1"><a class="tsl__n" href="' + esc(it.u) + '">' + esc(it.t) + '</a><span class="tsl__p" dir="ltr"></span></div>' +
        '<div class="tsl__os">' + opts + '</div>' +
        '<p class="tsl__need" aria-live="polite"></p>' +
      '</div>' +
    '</li>';
  }

  /* refresh chips, prices, photos and the button from the state */
  function sync() {
    var on = 0, live = 0, sum = 0;
    look.items.forEach(function (it, i) {
      var li = el.list.children[i];
      if (!li) return;
      li.classList.toggle('is-un', it.live && !it.on);
      li.querySelector('.tsl__p').textContent = money(price(it));
      var im = li.querySelector('.tsl__th img'), src = img(it);
      if (src && im.getAttribute('src') !== src) im.setAttribute('src', src);
      li.querySelectorAll('.tsl__c').forEach(function (c) {
        var k = +c.getAttribute('data-k'), val = c.getAttribute('data-val');
        var ok = it.v.some(function (v) { return v.a && v.o[k] === val && fits(it, v, k); });
        var cur = it.sel[k] === val;
        c.classList.toggle('is-on', cur);
        c.setAttribute('aria-pressed', cur ? 'true' : 'false');
        c.classList.toggle('is-off', !ok);
        c.disabled = !ok;
      });
      if (it.live) live++;
      if (it.on) { on++; sum += price(it); }
    });
    el.bl.textContent = on > 1 && on === live ? T.look : T.add;
    el.sum.textContent = on ? money(sum) : '';
    el.go.classList.toggle('is-dim', !on);
  }

  function choose(chip) {
    var li = chip.closest('.tsl__it'), it = look.items[+li.getAttribute('data-i')], k = +chip.getAttribute('data-k');
    it.sel[k] = chip.getAttribute('data-val');
    /* a colour change can leave the picked size sold out */
    it.sel.forEach(function (s, j) {
      if (j === k || s == null) return;
      if (!it.v.some(function (v) { return v.a && fits(it, v, -1); })) it.sel[j] = uniq(it.v.map(function (v) { return v.o[j]; })).length === 1 ? s : null;
    });
    if (!it.on) { it.on = true; li.querySelector('.tsl__tick input').checked = true; }
    need(it, '');
    el.msg.textContent = '';
    sync();
  }

  function need(it, txt) {
    var li = el.list.children[look.items.indexOf(it)];
    if (!li) return;
    li.querySelector('.tsl__need').textContent = txt;
    li.classList.toggle('is-need', !!txt);
  }

  /* ---------- open / close ---------- */
  function open(a, data) {
    if (!panel) build();
    clearTimeout(closing);
    look = prep(JSON.parse(JSON.stringify(data)));
    opener = a;
    el.t.textContent = look.title || '';
    el.img.src = look.img || '';
    el.img.alt = look.title || '';
    el.list.innerHTML = look.items.map(row).join('');
    el.msg.textContent = '';
    el.go.disabled = false;
    el.go.classList.remove('is-busy');
    sync();
    panel.hidden = false;
    document.documentElement.classList.add('tsc-lock', 'tsl-lock');
    void panel.offsetWidth;
    panel.classList.add('is-open');
    el.list.scrollTop = 0;
    setTimeout(function () { try { el.box.focus({ preventScroll: true }); } catch (e) { el.box.focus(); } }, 30);
  }

  function close(back) {
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('tsl-lock');
    if (!document.querySelector('.tsc.is-sheet')) document.documentElement.classList.remove('tsc-lock');
    closing = setTimeout(function () { panel.hidden = true; }, 400);
    if (back && opener) try { opener.focus({ preventScroll: true }); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-look-open]');
    if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var li = a.closest('.tsc-look'), s = li && li.querySelector('script[data-look-json]');
    if (!s) return;
    var data = li._tsl;
    if (!data) { try { data = li._tsl = JSON.parse(s.textContent); } catch (err) { return; } }
    if (!data.items || !data.items.length) return;
    e.preventDefault();
    open(a, data);
  });

  /* ---------- add to bag ---------- */
  function add() {
    if (busy || !look) return;
    var list = [], miss = null;
    look.items.forEach(function (it) {
      if (!it.on) return;
      var v = variant(it);
      if (v && v.a) { list.push({ id: v.id, quantity: 1 }); need(it, ''); return; }
      var k = it.sel.indexOf(null);
      need(it, k > -1 && it.kind[k] === 'c' ? T.color : T.size);
      if (!miss) miss = it;
    });
    if (miss) {
      var li = el.list.children[look.items.indexOf(miss)];
      if (li && li.scrollIntoView) li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    if (!list.length) { el.msg.textContent = T.none; return; }
    busy = true;
    el.msg.textContent = '';
    el.go.classList.add('is-busy');
    el.go.setAttribute('aria-busy', 'true');

    var secs = ['page-header', 'cart-drawer'].map(function (q) { return document.querySelector(q); })
      .filter(function (n) { return n && n.dataset && n.dataset.sectionId; });
    var body = { items: list };
    if (secs.length) {
      body.sections = secs.map(function (n) { return n.dataset.sectionId; }).join(',');
      body.sections_url = window.location.pathname;
    }
    var stop = typeof AbortController === 'function' ? new AbortController() : null;
    var stopTimer = stop ? setTimeout(function () { stop.abort(); }, 15000) : 0;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
      signal: stop ? stop.signal : undefined
    })
      /* a busy store can answer with a bot check page instead of JSON: that is a plain "try again", never raw text */
      .then(function (res) { return res.json().catch(function () { return null; }).then(function (j) { return { ok: res.ok, j: j }; }); })
      .then(function (r) {
        clearTimeout(stopTimer);
        var j = r.j;
        if (!r.ok || !j || j.status) {
          var er = new Error(j && typeof j.description === 'string' ? j.description : '');
          er.fromCart = true;
          throw er;
        }
        var updated = false;
        if (j.sections) {
          secs.forEach(function (n) {
            var html = j.sections[n.dataset.sectionId];
            if (html && typeof n.updateFromCartChange === 'function') { n.updateFromCartChange(html); updated = true; }
          });
        }
        if (!updated) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { items: list } }));

        el.go.classList.remove('is-busy');
        el.go.removeAttribute('aria-busy');
        close(false);
        var after = window.theme && window.theme.settings ? window.theme.settings.afterAddToCart : 'drawer';
        var drawer = document.querySelector('.js-cart-drawer');
        if (after === 'page' || !drawer || typeof drawer.open !== 'function') {
          window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart) || root + 'cart';
        } else {
          drawer.open(opener);
        }
        /* the bag is sliding in: a second tap in the meantime is not a second set */
        setTimeout(function () { busy = false; }, 700);
      })
      .catch(function (err) {
        clearTimeout(stopTimer);
        el.go.classList.remove('is-busy');
        el.go.removeAttribute('aria-busy');
        el.msg.textContent = err && err.fromCart && err.message && !/[<{]/.test(err.message) ? err.message : T.error;
        busy = false;
      });
  }
})();
